export default __webpack_public_path__ + "static/media/red_squirrel.77105cfc.jpg";